var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import MuiSnackbar from "@mui/material/Snackbar";
import Alert from "../Alert";
var Snackbar = function (_a) {
    var _b = _a.anchorOrigin, anchorOrigin = _b === void 0 ? { vertical: "top", horizontal: "center" } : _b, _c = _a.autoHideDuration, autoHideDuration = _c === void 0 ? 4000 : _c, _d = _a.defaultCloseIcon, defaultCloseIcon = _d === void 0 ? true : _d, _e = _a.theme, theme = _e === void 0 ? "dark" : _e, customNotificationIcon = _a.customNotificationIcon, _f = _a.showNotificationIcon, showNotificationIcon = _f === void 0 ? true : _f, // by default show notification icon but dont require it
    displayAsColumn = _a.displayAsColumn, _g = _a.iconFlexAlign, iconFlexAlign = _g === void 0 ? "center" : _g, // display icon center aligned with message or at the top left (flex-start)
    actions = _a.actions, message = _a.message, _h = _a.alertProps, alertProps = _h === void 0 ? { icon: false } : _h, rest = __rest(_a, ["anchorOrigin", "autoHideDuration", "defaultCloseIcon", "theme", "customNotificationIcon", "showNotificationIcon", "displayAsColumn", "iconFlexAlign", "actions", "message", "alertProps"]);
    var alertRef = useRef(null);
    return (_jsx(_Fragment, { children: _jsx(MuiSnackbar, __assign({ anchorOrigin: anchorOrigin, autoHideDuration: autoHideDuration }, rest, { children: _jsx(Alert, { defaultCloseIcon: defaultCloseIcon, theme: theme, customNotificationIcon: customNotificationIcon, showNotificationIcon: showNotificationIcon, displayAsColumn: displayAsColumn, iconFlexAlign: iconFlexAlign, alertProps: alertProps, message: message, onClose: rest.onClose, actions: actions, ref: alertRef }) })) }));
};
export default Snackbar;
